export default __webpack_public_path__ + "static/media/gestaoLogo.bdba3b56.png";